import { css } from '@emotion/react';

const notificationStyles = {
    container: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '15px',
        gap: '5px',
        background: '#303030',
        borderRadius: '8px',
    }),
    text: css({
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '10px',
        lineHeight: '15px',
        color: '#F6F8FA',
        marginRight: 20,
    }),
};

export default notificationStyles;
